export default __webpack_public_path__ + "static/media/result_2.db219a5f.jpg";